import { ModuleType } from "entities/modules/types";
import { ModuleDetailsTabs } from "../../context/types";

type TabProps = {
  id: string;
  "aria-controls": string;
};

export const getTabProps = (tab: ModuleDetailsTabs): TabProps => ({
  id: `module-tab-${tab}`,
  "aria-controls": `module-tabpanel-${tab}`,
});

type ModuleTab = {
  id: ModuleDetailsTabs;
  label: string;
};

export const gamesModuleTabs: ModuleTab[] = [
  { id: ModuleDetailsTabs.Tags, label: "Populate" },
  { id: ModuleDetailsTabs.SelectedGames, label: "Matching games" },
];

export const studiosModuleTabs: ModuleTab[] = [
  { id: ModuleDetailsTabs.Studios, label: "Studios" },
];

type GetTabsByModuleTypeParams = {
  moduleType: ModuleType;
  studioFilterEnabled?: boolean;
};

export const getTabsByModuleType = (
  params: GetTabsByModuleTypeParams,
): ModuleTab[] => {
  switch (params.moduleType) {
    case ModuleType.Studios:
      return studiosModuleTabs;
    case ModuleType.Games:
      return gamesModuleTabs;
    default:
      return [];
  }
};
